<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-input
          @input.native="onGroupsSearch"
          v-model="search"
          class="input--200"
          type="search"
          placeholder="Search by group name"
          name="search"
        />
      </app-cells>
      <div v-for="climbing_table_item of climbing_table" :key="climbing_table_item.name" class="climbing-block">
        <app-cells v-if="climbing_table_item.name">
          <h2 class="title">{{ climbing_table_item.name }}</h2>
          <div v-if="climbing_table_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
        </app-cells>
        <v-client-table
          :data="climbing_table_item.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
          :class="{ 'table-default--loading': table_preloader }"
          @row-click="openGroupPreview"
        >
          <template #h__route.name><div class="table-default__left">Route</div></template>
          <template #h__name><div class="table-default__left">Name</div></template>
          <template #h__type><div class="table-default__left">Type</div></template>
          <template #name="{ row }">
            <div class="table-default__left">
              <router-link
                :to="{ name: 'climbing-groups-detail-clients', params: { id: row.id } }"
                class="table-default__link-border table-default__link-border--inline"
              >
                {{ row.name }}
              </router-link> ({{ row.pax }})
            </div>
          </template>
          <template #tour_start="{ row }">
            {{ dateFormat(row.tour_start) }}
          </template>
          <template #tour_end="{ row }">
            {{ dateFormat(row.tour_end) }}
          </template>
          <template #type="{ row }">
            <div class="table-default__left">
              <span class="status-tag" :style="{ 'backgroundColor': row.type.color || '#8a8a8a' }">
                {{ row.type ? row.type.name : '-' }}
              </span>
            </div>
          </template>
          <template #route.name="{ row }">
            <div class="table-default__left">{{ row.route.name }} {{ row.route.duration }}</div>
          </template>
        </v-client-table>
      </div>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table_length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getClimbingGroupsByDates } from '@/http'
import debounce from 'lodash/debounce'
import { format, parse } from 'date-fns'
import previewRow from './previewRow'

export default {
  name: 'ClimbingGroupsArchiveList',
  mixins: [previewRow],
  data() {
    return {
      is_loaded: false,
      search: null,
      climbing_table: [],
      table_length: 0,
      table: {
        items: [],
        columns: ['name', 'type', 'route.name', 'tour_start', 'tour_end'],
        options: {
          headings: {
            'name': 'Name',
            'type': 'Type',
            'route.name': 'Route',
            'tour_start': 'Start',
            'tour_end': 'Finish',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM') : '-'
    },
    fetchItems() {
      const params = {
        page: this.pagination.page,
        page_size: 40,
        search: this.search,
        category: 'past',
        group_by: 'tour_start',
        range_type: 'month',
        ordering: '-tour_start'
      }
      getClimbingGroupsByDates(params)
        .then(res => {
          this.climbing_table = res.data.results.length ? res.data.results : [{name: '', items: []}]
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.table_length = 0
          res.data.results.forEach(item => {
            this.table_length += item.items.length
          })
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onGroupsSearch() {
      this.table_preloader = true
      this.searchGroups(this)
    },
    searchGroups: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
  }
}
</script>

<style lang="sass" scoped>
.climbing-block
  margin-bottom: 30px
</style>
